import { WidgetPosition } from '@shareview/sessionmanager-api-client';
import { CastLayoutType } from '../types';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace CastingActions {
  const NAMESPACE = '[Casting]';

  export class JoinSession {
    public static readonly type = `${NAMESPACE} Join Session`;

    public constructor(public sessionId: string) {
    }
  }

  export class LeaveSession {
    public static readonly type = `${NAMESPACE} Leave Session`;

    public constructor(public sessionId: string) {
    }
  }

  export class ChangeLayout {
    public static readonly type = `${NAMESPACE} Set Layout`;

    public constructor(public layout: CastLayoutType, public widgets: WidgetPosition[]) {
    }
  }

  export class Reset {
    public static readonly type = `${NAMESPACE} Reset`;
  }
}
